import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import configureStore from "./Store/main";

import Main from "./routes/Main";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render( <Provider store={configureStore({})}>
    <Main />
  </Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
